import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PackageTable } from '../../components/Package/PackageTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { useSelector } from 'react-redux';

export const Packages = () => {
  const {
    privileges: { packages: privileges = [] },
  } = useSelector((state) => state.userAuth);
  const navigate = useNavigate();

  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      {privileges.includes('create') && (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            navigate('/dashboard/paquetes/crear');
          }}
        >
          <PlusOutlined />
          Nuevo
        </Button>
      )}
      <PackageTable title="Paquetes" privileges={privileges} />
    </Card>
  );
};
